/**
 * Live updates of the sales / support inbox screens.
 *
 * Once a change to inbox items commits — whoever made it: a colleague, the
 * n8n classifier, a job — the backend pushes `changeInfoSalesInboxItem` to the
 * account, with `content.items = [{secId, inboxType, status, removed}]`.
 * watch() hands a view those items, gathered over a short window so a burst
 * of changes costs one refresh, and held back while a menu or a window is
 * open so nothing moves under the user's mouse.
 *
 * The notification carries no data: the view re-reads what it shows under
 * its own filters, and drops what no longer matches.
 */
define('salesInboxLiveUpdates',[
  'jquery',
  'underscore',
  'notificationCenter'
], function ($, _, NotificationCenter) {
  'use strict';

  var GATHER_MS = 800;
  var BUSY_RETRY_MS = 2000;

  // A status menu, an assignee picker or the email window is open.
  function busy() {
    return $('.wl-status-menu:visible, .si-status-menu:visible, .modal.in').length > 0;
  }

  return {
    watch: function (view, handler) {
      var pending = {};
      var timer = null;

      function flush() {
        timer = null;
        if (view.isDestroyed) { return; }
        if (busy()) {
          timer = window.setTimeout(flush, BUSY_RETRY_MS);
          return;
        }
        var items = _.values(pending);
        pending = {};
        if (items.length) { handler.call(view, items); }
      }

      NotificationCenter.getInstance().addListener(view, NotificationCenter.events.SALES_INBOX_ITEM_CHANGED,
        function (message) {
          var items = message && message.content && message.content.items;
          _.each(items || [], function (item) {
            if (item && item.secId) { pending[item.secId] = item; }
          });
          if (!timer) { timer = window.setTimeout(flush, GATHER_MS); }
        });

      view.listenTo(view, 'before:destroy', function () {
        if (timer) { window.clearTimeout(timer); }
        timer = null;
      });
    },

    /** The changed items a board shows a row of (rows carry data-secid). */
    shownOn: function ($scope, items) {
      return _.filter(items, function (item) {
        return $scope.find('[data-secid="' + item.secId + '"]').length > 0;
      });
    },

    /** Whether any of the changes is about the given inbox (SALES / SUPPORT). */
    concerns: function (items, inbox) {
      return _.some(items, function (item) { return item.inboxType === inbox; });
    }
  };
});

